import React from 'react';

import {
	Chart as ChartJS,
	ArcElement,
	Tooltip,
	Legend,
	ChartData,
	ChartType,
	CoreChartOptions,
	DatasetChartOptions,
	DefaultDataPoint,
	DoughnutControllerChartOptions,
	ElementChartOptions,
	PluginChartOptions,
	ScaleChartOptions,
} from 'chart.js';
import { _DeepPartialObject } from 'chart.js/dist/types/utils.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

type TType = ChartType;
type TData = DefaultDataPoint<TType>;
type TLabel = unknown;

interface IDoughnutChartProps {
	options?: _DeepPartialObject<
		CoreChartOptions<'doughnut'> &
			ElementChartOptions<'doughnut'> &
			PluginChartOptions<'doughnut'> &
			DatasetChartOptions<'doughnut'> &
			ScaleChartOptions<'doughnut'> &
			DoughnutControllerChartOptions
	>;
	data: ChartData<'doughnut', TData, TLabel>;
}

const DoughnutChart: React.FunctionComponent<IDoughnutChartProps> = ({
	options = {},
	data,
}) => {
	const doughnutLabel = {
		id: 'textCenter',
		beforeDatasetsDraw(chart: any) {
			const { ctx, data } = chart;
			ctx.save();
			ctx.font = 'bolder 48px sans-serif';
			ctx.fillStyle = 'black';
			ctx.textAlign = 'center';
			ctx.txtBaseline = 'middle';
			ctx.fillText(
				data.datasets[0].total ? data.datasets[0].total : 0,
				chart.getDatasetMeta(0).data[0].x,
				chart.getDatasetMeta(0).data[0].y,
			);
		},
	};

	return (
		<Doughnut
			data-testid="doughnuttestId"
			data={data}
			options={options}
			plugins={[doughnutLabel]}
		/>
	);
};

export default DoughnutChart;
